import Block from './block';

export default {
	component: Block,
	getChildren() { return []; }
};

